export const CAAS_ACTIONS = {
  caas_schedule: {
    id: 'caas-schedule',
    name: 'Create CaaS Work Order',
  },
  caas_updates: {
    id: 'caas-updates',
    name: 'Update CaaS Work Order',
  },
  caas_completion: {
    id: 'caas-completion',
    name: 'Close CaaS Work Order',
  },
};

export const ADDRESS_OPTS = {
  currentAddress: 'currentAddress',
  newAddress: 'newAddress',
};

export const CONTACT_OPTS = {
  currentContact: 'currentContact',
  newContact: 'newContact',
};
